import React, { useEffect, useState } from "react";
import { useHttpClient } from "../../hooks/useHttpClient";
import { useLocalization } from "../../stores/localizationContext";
import { useUserContext } from "../../stores/userContext";
import "./Profile.scss";

interface EducatorProfile {
  educator_first_name: string;
  educator_last_name: string;
  educator_email: string;
}

const Profile: React.FC = () => {
  const { user } = useUserContext();
  const api = useHttpClient();
  const { t } = useLocalization();

  const [profileData, setProfileData] = useState<EducatorProfile | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!user?.userId) return;

      setError(null);

      try {
        const endpoint = import.meta.env.VITE_GET_EDUCATOR_PROFILE.replace(
          "{educator_id}",
          user.userId
        );
        const response = await api.get(endpoint);
        setProfileData(response.data);
      } catch (err: any) {
        setError(t("profile_load_error", "Failed to load profile."));
      }
    };

    fetchProfile();
  }, [user?.userId]);

  return (
    <div className="profile-page">
      <div className="container">
        <div className="profile-page__content">
          <div className="profile-page__header">
            <h1 className="profile-page__title">{t("profile_label", "Profile")}</h1>
          </div>

          {error && (
            <div className="profile-page__error" role="alert">
              {error}
            </div>
          )}

          {!error && profileData && (
            <section className="profile-page__section" aria-labelledby="account-info-label">
              <p id="account-info-label" className="profile-page__section-title">
                {t("account_info_label", "Account Info")}
              </p>
              <div className="profile-page__card">
                <div className="profile-page__fields-row">
                  <div
                    className="profile-page__field"
                    aria-label={t("first_name_label", "First Name")}
                  >
                    {profileData.educator_first_name}
                  </div>
                  <div
                    className="profile-page__field"
                    aria-label={t("last_name_label", "Last Name")}
                  >
                    {profileData.educator_last_name}
                  </div>
                </div>
                <div
                  className="profile-page__field"
                  aria-label={t("email_label", "Email")}
                >
                  {profileData.educator_email}
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
